// @ts-nocheck

import { storage } from './';

const saveSocketOnStorage = (suggestedSocket) => {
  const { host, path } = suggestedSocket;
  if (host && path) {
    storage.localStorage.save('application:socket', suggestedSocket);
  }
};

export default saveSocketOnStorage;
